import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { appendRelationship } from '../../requests/appendRelationship';

type AppendRelationshipVariables = {
  uuid: string;
  definition: string;
  children: string[];
  data: Record<string, any>;
};

export const useAppendRelationship = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      definition,
      children,
      data,
    }: AppendRelationshipVariables) =>
      appendRelationship(constructPost, uuid, definition, children, data),
    onSuccess: () => handleSuccess('Additional asset added successfully'),
    onError: () => handleError('Failed to add additional asset'),
  });
  return { appendRelationship: mutateAsync, ...rest };
};
